"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shiftTypePolicies = void 0;
exports.shiftTypePolicies = {
    Shift: {
        keyFields: false
    }
};
